import React, {Component} from 'react'
import {connect} from 'react-redux'

import ContentColumn from '../../components/GridColumn/GridColumn'
import AccountListComponent from '../../components/AccountList/AccountList'

import {updateAccountList} from '../../store/actions/storage'

import classes from './AccountList.module.scss'

class AccountList extends Component {
	updateAccountList = url => {
		this.props.updateAccountList(url)
	}

	render() {
		return (
			<ContentColumn>
				<AccountListComponent
					listClassName={classes.AccountList}
					accountList={this.props.accountList}
					onLinkClick={this.updateAccountList}
				/>
			</ContentColumn>
		)
	}
}

const mapStateToProps = state => ({
	accountList: state.storage.accountList
})

const mapDispatchToProps = dispatch => ({
	updateAccountList: account => dispatch(updateAccountList(account))
})

export default connect(mapStateToProps, mapDispatchToProps)(AccountList)